import type { OrderSearchFilter } from '../types/order-search-filter-constants.type'

export const ORDER_SEARCH_PARAMS: OrderSearchFilter[] = [
  {
    id: '1',
    text: 'Código',
    parameter: 'id_pedido',
  },
  {
    id: '2',
    text: 'Data emissão',
    parameter: 'data_emissao',
  },
  {
    id: '3',
    text: 'Cliente',
    parameter: 'c.razao_social_nome',
  },
	{
    id: '5',
    text: 'CNPJ/CPF',
    parameter: 'c.cnpjcpf',
  },
  {
    id: '4',
    text: 'Status',
    parameter: 's.sigla',
  },
]
